import { render, staticRenderFns } from "./VerticalSlider.vue?vue&type=template&id=e4d63708&scoped=true"
import script from "./VerticalSlider.vue?vue&type=script&lang=js"
export * from "./VerticalSlider.vue?vue&type=script&lang=js"
import style0 from "./VerticalSlider.vue?vue&type=style&index=0&id=e4d63708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d63708",
  null
  
)

export default component.exports